module.exports = __webpack_public_path__ + "static/img/t2.ae3e722.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/t2.jpg
// module id = f7K2
// module chunks = 1